import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { EquipmentInfoIdSchema, EquipmentInfoSchema, PopulatedEquipmentTableSelectSchema, } from '../equipment/equipment.types.js';
import { MovementInfoIdSchema, MovementInfoSchema, PopulatedMovementTableSelectSchema, } from '../movement/movement.types.js';
// ===== ID SCHEMAS =====
const ExerciseIdSchema = createIdSchema('exercise');
const ExerciseTableSelectSchema = createStrictSchema()({
    id: ExerciseIdSchema,
    movementId: MovementInfoIdSchema,
    equipmentId: EquipmentInfoIdSchema,
    equipmentCount: z.number().int().min(1),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== POPULATED SCHEMAS =====
const PopulatedExerciseTableSelectSchema = ExerciseTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    movement: PopulatedMovementTableSelectSchema,
    equipment: PopulatedEquipmentTableSelectSchema,
});
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
const ExerciseInfoSchema = ExerciseTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    updatedAt: z.string(),
});
const ExerciseInfoIdSchema = ExerciseIdSchema;
const PopulatedExerciseInfoSchema = PopulatedExerciseTableSelectSchema.extend({
    updatedAt: z.string(),
    movement: MovementInfoSchema,
    equipment: EquipmentInfoSchema,
});
export { ExerciseInfoSchema, ExerciseInfoIdSchema, PopulatedExerciseInfoSchema, ExerciseTableSelectSchema, PopulatedExerciseTableSelectSchema, };
//# sourceMappingURL=exercise.types.js.map